// extracted by mini-css-extract-plugin
export default {"container":"UserSearch_container__8lzBn"};